import { groupBy } from "lodash-es";
import SlideDown from "src/components/layout/SlideDown";
import AttendanceModel from "src/models/AttendanceModel";
import ClassModel from "src/models/ClassModel";
import MembershipOfferingModel from "src/models/MembershipOfferingModel";
import { useStore } from "src/stores/Store";
import tw from "src/utils/tw";
import {
  IntegrationType,
  MembershipStatus,
  OfferingStatus,
} from "types/code-generator";
import AdminClassRoster from "./AdminClassRoster";

interface Props {
  onClick: () => void;
  visible: boolean;
  class?: ClassModel;
  attendance?: AttendanceModel;
  membershipOffering?: MembershipOfferingModel;
  isPreview?: boolean;
  className?: string;
}

export default function ShowEnrollments(props: Props) {
  const store = useStore();

  let isEmpty = false;
  let showRosterToggle = true;
  let roster = [];
  let pending = [];
  let waitlist = [];

  if (props.class) {
    if (props.class.requiresRegistration === false) {
      const memberships = props.class.membershipOfferings.flatMap(
        (mo) => mo.memberships || []
      );
      const membershipAccounts = groupBy(memberships, (m) => m.accountOwnerId);
      roster = Object.keys(membershipAccounts);
      showRosterToggle = false;
    } else {
      const classWaitlist = props.class.getWaitlist();
      const classPending = props.class.getPending();

      roster = props.class
        .getRoster()
        .filter((s) => !classPending.find((rs) => rs.id === s.id));
      waitlist = classWaitlist;
      pending = classPending;
    }
  } else if (props.attendance) {
    roster = props.attendance.students;
    waitlist = [];
  } else if (props.membershipOffering) {
    const membershipOfferingPending = props.membershipOffering.getPending();
    const membershipOfferingWaitlist =
      props.membershipOffering.memberships.filter(
        (m) => m.status === MembershipStatus.Waitlist
      );

    roster = props.membershipOffering.getRoster();
    waitlist = membershipOfferingWaitlist;
    pending = membershipOfferingPending;
  }

  if (
    (roster.length === 0 && waitlist.length === 0 && pending.length === 0) ||
    (props.attendance && props.attendance.students.length === 0)
  ) {
    isEmpty = true;
  }

  if (props.attendance && isEmpty) {
    return null;
  }

  let enrolled = `${roster.length.toLocaleString()} enrolled`;

  if (props.membershipOffering) {
    enrolled = `${roster.length.toLocaleString()} members`;
  }

  if (pending.length > 0) {
    enrolled += ` • ${pending.length.toLocaleString()} pending`;
  }

  if (props.class?.requiresRegistration === false) {
    enrolled = `Available to ${roster.length.toLocaleString()} ${store.organization.terminology.customer.toLowerCase()}${roster.length !== 1 ? "s" : ""}`;

    if (props.class?.checkIn) {
      enrolled += " for check in";
    }
  }

  if (props.class?.requiresRegistration) {
    if (props.class.maxEnrollment === null) {
      enrolled += ` • Unlimited Spots`;
    } else {
      enrolled += ` • ${Math.max(
        0,
        props.class.maxEnrollment - props.class.getRoster().length
      ).toLocaleString()} available`;
    }
  }

  if (props.membershipOffering) {
    enrolled = `${roster.length.toLocaleString()} members`;

    if (props.membershipOffering.integration === IntegrationType.USASwimming) {
    } else if (props.membershipOffering.maxEnrollment === null) {
      enrolled += ` • Unlimited Spots`;
    } else {
      enrolled += ` • ${Math.max(
        0,
        props.membershipOffering.maxEnrollment -
          props.membershipOffering.getRoster().length
      ).toLocaleString()} available`;
    }
  }

  if (waitlist.length > 0) {
    enrolled += ` • ${waitlist.length.toLocaleString()} waitlist`;
  }

  if (props.class?.status === OfferingStatus.Archived) {
    enrolled = `${props.class
      .getClosedRegistrations()
      .length.toLocaleString()} enrolled all-time`;
  }

  // if (props.class?.semiPrivate) {
  //   if (props.class.getRoster().length > 0) {
  //     enrolled = `1 account enrolled`;
  //   } else {
  //     enrolled = `Available`;
  //   }
  // }

  // console.log("roster", roster);

  return (
    <div
      className={tw(
        "mt-2",
        "rounded",
        "border",
        "border-borderGray",
        "transition-all",
        "bg-white",
        !isEmpty && showRosterToggle && "cursor-pointer",
        props.visible ? "max-w-full" : "max-w-sm",
        props.className
      )}
    >
      <div
        className="flex px-2 py-1 text-sm"
        onClick={isEmpty || !showRosterToggle ? undefined : props.onClick}
      >
        {!props.isPreview && (
          <div className="flex flex-1 items-center gap-2">
            {!props.class?.requiresRegistration && (
              <div>
                <i className="far fa-map-pin" />
              </div>
            )}
            <div className="flex-1">{enrolled}</div>
          </div>
        )}
        {!isEmpty && showRosterToggle && (
          <div className="ml-4 text-organization">
            {props.visible ? "Hide" : "Show"}
          </div>
        )}
      </div>
      <SlideDown>
        {props.visible && (
          <AdminClassRoster
            roster={roster}
            waitlist={waitlist}
            pending={pending}
          />
        )}
      </SlideDown>
    </div>
  );
}
